import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import { qdtComponents } from "../config/globalApp";
import { SelectionOptionsType } from "../pages/Leaderboard";

type appContextType = {
  showFilter: boolean;
  toggleShowFilter: () => void;
  clearAllSelections: () => void;
  goToTop: () => void;
  entrantSelected: SelectionOptionsType | null | undefined;
  setEntrantSelected: (value: SelectionOptionsType | undefined) => void;
  groupTeamCompanySelected: SelectionOptionsType | null | undefined;
  setGroupTeamCompanySelected: (
    value: SelectionOptionsType | undefined
  ) => void;
  playerSelected: SelectionOptionsType | null | undefined;
  setPlayerSelected: (value: SelectionOptionsType | undefined) => void;
};

const appDefaultValues: appContextType = {
  toggleShowFilter: () => {},
  clearAllSelections: () => {},
  goToTop: () => {},
  showFilter: false,
  entrantSelected: null,
  setEntrantSelected: () => {},
  groupTeamCompanySelected: null,
  setGroupTeamCompanySelected: () => {},
  playerSelected: null,
  setPlayerSelected: () => {},
};

const AppContext = createContext<appContextType>(appDefaultValues);

export function useApp() {
  return useContext(AppContext);
}

type Props = {
  children: ReactNode;
};

export function AppProvider({ children }: Props) {
  const [showFilter, setShowFilter] = useState(false);
  const [entrantSelected, setEntrantSelected] =
    useState<SelectionOptionsType>();
  const [groupTeamCompanySelected, setGroupTeamCompanySelected] =
    useState<SelectionOptionsType>();
  const [playerSelected, setPlayerSelected] = useState<SelectionOptionsType>();

  const toggleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const clearAllSelections = async () => {
    const qApp = await qdtComponents.qAppPromise;
    await qApp?.clearAll();
    setEntrantSelected(undefined);
    setGroupTeamCompanySelected(undefined);
    setPlayerSelected(undefined);
  };

  const goToTop = useCallback(() => {
    window?.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const value = {
    toggleShowFilter,
    showFilter,
    goToTop,
    clearAllSelections,
    entrantSelected,
    setEntrantSelected,
    groupTeamCompanySelected,
    setGroupTeamCompanySelected,
    playerSelected,
    setPlayerSelected,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
